import React from 'react'
import { Link } from 'react-router-dom';
import blogSingleInnnerImg1 from "../../assets/images/blog/blog-single-inner-img-1.png"

function Blogdtlsbred() {
  return (
    <div>
      <section className="page-header page-header-two">
        <div className="page-header-shape-1" />
        <div className="page-header-shape-2" />
        <div className="page-header-shape-3" />
        <div className="page-header-shape-4" />
        <div className="container">
          <div className="page-header-inner text-center">
            <div
              className="blog-detail-header-title-text wow fadeInUp animated animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <ul className="text-center">
                <li>
                  <Link to="#">SEO Camping</Link>
                </li>
                <li className="blog-detail-single-name">
                  <img
                    src={blogSingleInnnerImg1}
                    alt="blog-single-inner-img-1"
                  />
                  <p>Matthew</p>
                </li>
                <li>
                  <Link to="#">September 20, 2023</Link>
                </li>
              </ul>
            </div>
            <h2
              className="swift-up-text blog-detail-header-title-title wow fadeInUp animated animated"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              Achieving Fashion Elegant Design Runway to Real Life
            </h2>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Blogdtlsbred
